<template>
	<div>
                <div class="tao no-checkout clearfix">
            <div class="clearfix">
            <div class="sai">
            <div class="foot-bone">
            <div class="sai-soc">
            <div class="jo">Be Social With Us</div>
            <ul class="clearfix soc-svg">
            <li class="fb">
            <a target="_other" class="soc-fb" href="https://www.facebook.com/BrightonCollectibles"><svg aria-labelledby="sti2" roll="img" viewBox="0 0 24.9 24.9" width="40" height="40"><title id="sti2">Follow Brighton on Facebook</title><circle class="svga" cx="12.45" cy="12.45" r="12.2"></circle><path class="svgb" d="M9.35,7.55v2.4H7.65v2.9h1.7v8.7H13v-8.6h2.4s.2-1.4.3-2.9H13v-2a.86.86,0,0,1,.8-.7h2v-3H13C9.25,4.25,9.35,7.15,9.35,7.55Z"></path></svg>
            <span>Visit Us on Facebook</span>
            </a>
            </li><li class="tw">
            <a target="_other" class="soc-tw" href="https://twitter.com/brighton"><svg aria-labelledby="sti3" roll="img" viewBox="0 0 24.9 24.9" width="40" height="40"><title id="sti3">Follow Brighton on Twitter</title><circle class="svga" cx="12.45" cy="12.45" r="12.2"></circle><path class="svgb" d="M20.45,8.15a12.09,12.09,0,0,1-1.8.5A3.91,3.91,0,0,0,20,6.95a7,7,0,0,1-2,.8,3.26,3.26,0,0,0-2.3-1,3.12,3.12,0,0,0-3.1,3.1,1.7,1.7,0,0,0,.1.7,8.61,8.61,0,0,1-6.4-3.3,2.93,2.93,0,0,0-.4,1.6,3.26,3.26,0,0,0,1.4,2.6,3.26,3.26,0,0,1-1.4-.4h0a3.21,3.21,0,0,0,2.5,3.1,2.2,2.2,0,0,1-.8.1,1.27,1.27,0,0,1-.6-.1,3.38,3.38,0,0,0,2.9,2.2A6.53,6.53,0,0,1,6,17.65h-.7a8.72,8.72,0,0,0,4.8,1.4,8.83,8.83,0,0,0,8.9-8.9v-.4A7.31,7.31,0,0,0,20.45,8.15Z"></path></svg>
            <span>Visit Us on Twitter</span>
            </a>
            </li><li class="yt">
            <a target="_other" class="soc-yt" href="https://www.youtube.com/user/BrightonCollectibles"><svg aria-labelledby="sti4" roll="img" viewBox="0 0 24.9 24.9" width="40" height="40"><title id="sti4">Follow Brighton on Youtube</title><circle class="svga" cx="12.45" cy="12.45" r="12.2"></circle><path class="svgb" d="M21.85,10.85a1.93,1.93,0,0,0-.5-1.1,1.31,1.31,0,0,0-1.1-.5c-1.6-.1-4-.1-4-.1h0s-2.4,0-4,.1a1.31,1.31,0,0,0-1.1.5,3.1,3.1,0,0,0-.5,1.1s-.1,1-.1,1.9v.8c0,.9.1,1.8.1,1.8a1.93,1.93,0,0,0,.5,1.1c.4.5,1,.4,1.3.5.9.1,3.9.1,3.9.1s2.4,0,4-.1a1.31,1.31,0,0,0,1.1-.5,3.1,3.1,0,0,0,.5-1.1s.1-.9.1-1.8v-.9C21.95,11.85,21.85,10.85,21.85,10.85Z"></path><path class="svgb" d="M9.95,15.65h-.7v-.4c-.3.3-.5.5-.8.5a.55.55,0,0,1-.5-.3,3.54,3.54,0,0,1-.1-.6v-3.1h.7v3.2c0,.1.1.1.2.1a.54.54,0,0,0,.4-.3v-3h.7v3.9Z"></path><path class="svgb" d="M7.35,13.05a2,2,0,0,0-.2-.9.91.91,0,0,0-.8-.4.91.91,0,0,0-.8.4,2,2,0,0,0-.2.9v1.4a2,2,0,0,0,.2.9.91.91,0,0,0,.8.4.91.91,0,0,0,.8-.4,2,2,0,0,0,.2-.9Zm-.7,1.4q0,.6-.3.6t-.3-.6v-1.5q0-.6.3-.6t.3.6Z"></path><path class="svgb" d="M4.45,13.55v2.1h-.8v-2.1s-.8-2.6-1-3.1h.9l.5,2,.5-2h.8Z"></path><path class="svgc" d="M21,13.85v-.8a2,2,0,0,0-.2-.9.91.91,0,0,0-.8-.4.81.81,0,0,0-.8.4,2,2,0,0,0-.2.9v1.3a2,2,0,0,0,.2.9.91.91,0,0,0,.8.4.81.81,0,0,0,.8-.4c.1-.1.1-.3.2-.4v-.6h-.7v.5a.27.27,0,0,1-.3.3c-.2,0-.3-.2-.3-.5v-.7Zm-1.4-1c0-.4.1-.5.3-.5s.3.1.3.5v.4h-.7v-.4Z"></path><path class="svgc" d="M17.75,11.75a1,1,0,0,0-.7.4v-1.7h-.7v5.1H17v-.4a.87.87,0,0,0,.7.4.55.55,0,0,0,.6-.4c0-.2.1-.4.1-.8v-1.5a1.72,1.72,0,0,0-.1-.8A.85.85,0,0,0,17.75,11.75Zm0,2.8c0,.4-.1.5-.3.5s-.2-.1-.4-.2v-2.3a.52.52,0,0,1,.4-.2c.2,0,.3.1.3.5Z"></path><path class="svgc" d="M15.75,15.65H15v-.4c-.3.3-.5.5-.8.5a.55.55,0,0,1-.5-.3,3.54,3.54,0,0,1-.1-.6v-3h.7v3.1c0,.1.1.1.2.1a.54.54,0,0,0,.4-.3v-2.9h.7v3.8Z"></path><polygon class="svgc" points="13.05 15.65 12.25 15.65 12.25 11.25 11.45 11.25 11.45 10.55 13.85 10.55 13.85 11.25 13.05 11.25 13.05 15.65"></polygon></svg>
            <span>Visit Us on Youtube</span>
            </a>
            </li><li class="in">
            <a target="_other" class="soc-in" href="https://instagram.com/brightoncollectibles/"><svg aria-labelledby="sti5" roll="img" viewBox="0 0 24.9 24.9" width="40" height="40"><title id="sti5">Follow Brighton on Instagram</title><circle class="svga" cx="12.45" cy="12.45" r="12.2"></circle><path class="svgb" d="M19.85,6.55a1.47,1.47,0,0,0-1.5-1.5H6.45a1.5,1.5,0,0,0-1.6,1.5v11.8a1.76,1.76,0,0,0,1.6,1.8h11.9a1.68,1.68,0,0,0,1.5-1.8Zm-7.4,4.3c.9-1.2,2.7-.5,2.7,1.2,0,1.1-.9,1.6-1.5,2.1s-1.2.9-1.2.9-.6-.5-1.2-.9a2.64,2.64,0,0,1-1.5-2.1A1.56,1.56,0,0,1,12.45,10.85Zm5.4,6.7c0,.3,0,.5-.3.5H7.25a.47.47,0,0,1-.5-.5v-6.5h1.2a8.33,8.33,0,0,0-.1,1.2,4.6,4.6,0,0,0,9.2,0,8.37,8.37,0,0,1-.1-1.2h1v6.5Zm0-8.3c0,.4-.2.8-.6.8h-1.8c-.3,0-.6-.4-.6-.8V7.55c0-.4.3-.5.6-.5h1.8c.3,0,.6.1.6.5Z"></path></svg>
            <span>Visit Us on Instagram</span>
            </a>
            </li><li class="pi">
            <a target="_other" class="soc-pi" href="https://www.pinterest.com/brightoncollect"><svg aria-labelledby="sti6" roll="img" viewBox="0 0 24.9 24.9" width="40" height="40"><title id="sti6">Follow Brighton on Pinterest</title><circle class="svga" cx="12.45" cy="12.45" r="12.2"></circle><path class="svgb" d="M12.05,15.15c-.4,2.3-1,4.5-2.6,5.7-.5-3.5.7-6.1,1.3-8.9-1-1.6.1-4.9,2.1-4.1,2.5,1-2.2,6,1,6.6s4.6-5.7,2.6-7.7c-2.9-3-8.5-.1-7.8,4.2.2,1,1.2,1.4.4,2.8-1.9-.4-2.4-1.9-2.4-3.9a6.31,6.31,0,0,1,5.7-5.8c3.5-.4,6.8,1.3,7.3,4.6.5,3.7-1.6,7.8-5.4,7.5C13.25,16.05,12.85,15.55,12.05,15.15Z"></path></svg>
            <span>Visit Us on Pinterest</span>
            </a>
            </li>
            </ul>
            </div>
            </div>
            </div>
            </div>
            <div class="hash">#mybrightonstyle</div>
            <div class="clearfix">
            <div class="foot-bone">
            <div class="koi">
            <div class="tao-store-locator">
            <div class="tc_spacer">
            <form name="zipForm" action="https://www.brighton.com/stores" method="post">
            <label for="store_locator_foot"><a href="https://www.brighton.com/stores">Store Locator</a></label>
            <div class="flexer2 clearfix">
            <input class="tc_input flexed Put mi_footer_enter_location input_field" id="store_locator_foot" name="zip" type="text" value="" placeholder="Enter City, State or Zip Code"><span><input type="submit" class="tc_btn modern_button mb_go" value="Go"></span>
            </div>
            <input type="hidden" name="search" value="1">
            </form>
            </div>
            </div>
            <div class="tao-email-signup">
            <div class="tc_spacer">
            <form name="confirmation" id="confirm">
            <input type="hidden" name="source" value="footer">
            <label id="email_address_24_label" for="email_address_24">Subscribe to Brighton.com!</label>
            <table cellspacing="0" cellpadding="0">
            <tbody><tr>
            <td><div class="Putter"><input class="Put mi_footer_email" id="email_address_24" type="email" name="email" value="" placeholder="Sign up for Emails!" onkeypress="javascript:if(event.keyCode == 13 || event.which == 13) {document.getElementById('email_signup_24').click(); return false;}"></div></td>
            <td class="shrink"><input name="email_signup" id="email_signup_24" class="go_button" type="submit" value="Sign Up"></td>
            </tr>
            <tr>
            <td><div class="Putter"><span id="email_address_24_error"></span></div></td>
            </tr>
            </tbody></table>
            </form>
            </div>
            </div>
            </div>
            
            <div class="niu">
            <ul class="clearfix">
            <li class="niu-topic">
            <ul class="clearfix">
            <li><a href="https://www.brighton.com/contact">Contact Us</a></li>
            <li><a href="https://www.brighton.com/content/34/help-and-faqs.html">Help &amp; FAQ's</a></li>
            <li><a href="https://www.brighton.com/order-status">Order Status</a></li>
            <li><a href="https://www.brighton.com/returns">Easy Returns</a></li>
            <li><a href="https://www.brighton.com/content/shipping">Shipping Information</a></li>
            <li><a href="https://www.brighton.com/charmbuilder/">Charm Builder</a></li>
            <li><a href="https://www.brighton.com/giftcards">Gift Cards</a></li>
            <li><a href="https://www.brighton.com/mailers/">Lookbooks</a></li>
            <li><a href="https://www.brighton.com/getthelook">Shop the Look</a></li>
            <li><a href="https://www.brighton.com/videos/">Videos</a></li>
            <li><a href="https://www.brighton.com/trending/">Trending</a></li>
            <li><a href="https://www.brighton.com/content/4808/site-map.html">Sitemap</a></li>
            </ul>
            </li>
            <li class="niu-topic">
            <ul class="clearfix">
            <li><a href="https://www.brighton.com/content/about-us">About Us</a></li>
            <li><a href="https://www.brighton.com/content/3486/uniquely-brighton.html">Uniquely Brighton</a></li>
            <li><a href="https://www.brighton.com/content/history">History</a></li>
            <li><a href="https://www.brighton.com/content/cares">Brighton Gives Back</a></li>
            <li><a href="https://www.brighton.com//brightoninsider">Brighton Insider</a>
            </li><li><a href="https://brightoncollectibles.com/careers/">Careers</a></li>
            <li><a href="https://www.brighton.com/content/privacy">Privacy Policy</a></li>
            <li><a href="https://www.brighton.com/content/terms">Terms &amp; Conditions</a></li>
            <li><a href="https://www.brighton.com/content/global">Global Citizenship</a></li>
            <li><a href="http://www.brightonretail.com/calendar/monthly_view.php">Retailer Events</a></li>
            <li><a href="https://brightoncollectibles.com/e-cards/">E-Greeting Cards</a></li>
            </ul>
            </li>
            </ul>
            </div>
            </div>
            </div>
            <div class="mot clearfix">
            <div class="foot-bone">
            <div class="contact-num">
            <span class="foot-no-mobile"><b>Customer Care</b> </span><span class="foot-no-mobile">(800) 628-7687</span><span class="foot-only-mobile"><a href="tel:+18006287687">(800) 628-7687</a></span><span class="foot-hours"> Mon-Fri 7am - 5pm PDT</span><br><a href="https://www.brighton.com/content/47/accessibility.html"><b>Website Accessibility</b></a>
            </div>
            <div id="external-retail-key" class="clearfix">
            <a target="_other" href="http://www.brightonretail.com/">
            <span>Brighton Retailers</span>
            </a>
            </div>
            <div class="copy-finale tc_ghost">© 2018 Brighton Collectibles, LLC. All rights reserved.</div>
            </div>
            </div>
            </div>
						
	</div>
</template>
<style scoped>
	#footer{
		margin-top:40px;
		text-align:center;
		display:block;
		
	}
	#footer ul{
		float: none;
	    display: inline-block;
	    list-style: none;
	}
    #footer ul li a{
        margin:10px;
        display:block;
        font-weight:bold;
        text-decoration:none;
    }
	#stage{
		width:960px;
	}
</style>
<script>
	export default {
	  	name: 'brfooter',
		props: {
			// storeType: Number
		}
	}
</script>